import SortSwitcher from './SortSwitcher';

export default SortSwitcher;
